module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-600.437844ee60c122bea4be.svg";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-600.svg
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-600.svg
// module chunks = styles